<template>
    <div class="container pt-2">
        <PageTitle main="Modalidades Aceitas" sub="Cadastrar, alterar ou deletar Modalidades Aceitas" />
        <b-form>
            <input id="colaborador_subcategoria-id" type="hidden" v-model="colaborador_subcategoria.id" />
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Categoria:" label-for="colaborador_subcategoria-categoria">
                        <b-form-select id="colaborador_subcategoria-categoria" :options="categorias"
                            v-model="colaborador_subcategoria.categoria_id"
                            placeholder="Informe categoria."
                            :class="{ 'inputError': $v.colaborador_subcategoria.categoria_id.$error }"
                            @keydown.tab="$v.colaborador_subcategoria.categoria_id.$touch"
                            @change="loadSubcategorias"/>
                        <span class="error" v-if="!$v.colaborador_subcategoria.categoria_id.required && $v.colaborador_subcategoria.categoria_id.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Subcategoria:" label-for="colaborador_subcategoria-subcategoria">
                        <b-form-select id="colaborador_subcategoria-subcategoria" :options="subcategorias"
                            v-model="colaborador_subcategoria.id_subcategoria"
                            placeholder="Informe subcategoria."
                            :class="{ 'inputError': $v.colaborador_subcategoria.id_subcategoria.$error }"
                            @keydown.tab="$v.colaborador_subcategoria.id_subcategoria.$touch"/>
                        <span class="error" v-if="!$v.colaborador_subcategoria.id_subcategoria.required && $v.colaborador_subcategoria.id_subcategoria.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" class="btn-custom" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 btn-custom" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-colaborador_subcategorias" 
                class="text-center table table-sm" 
                :items="colaborador_subcategorias" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadColaborador_subcategoria(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-colaborador_subcategorias"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-colaborador_subcategorias" 
                class="text-center table table-sm" 
                :items="colaborador_subcategorias" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadColaborador_subcategoria(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-colaborador_subcategorias"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'colaborador_subcategorias',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            colaborador_subcategoria: {},
            colaborador_subcategorias: [],
            colaborador: {},
            colaboradores: [],
            categoria: {},
            categorias: [],
            subcategoria: {},
            subcategorias: [],
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'colaborador_nome', label: 'Colaborador', sortable: true },
                { key: 'categoria_titulo', label: 'Categoria', sortable: true },
                { key: 'subcategoria_titulo', label: 'Subcategoria', sortable: true },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' } }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        rows() {
            return this.colaborador_subcategorias.length
        }
    },
        validations: {
        colaborador_subcategoria: {
            id_colaborador: {
                required
            },
            categoria_id: {
                required
            },
            id_subcategoria: {
                required
            }
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadCategorias() {
            const url = `${baseApiUrl}/backend/SELECT/categorias.php`
            axios.get(url).then(res => {
                this.categorias = res.data.map(categoria => {
                    return { ...categoria, value: categoria.id, text: categoria.titulo }
                })
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.categoria =  { value: '', text: 'Cadastre uma categoria antes.' }
            }
            )
        },
        loadSubcategorias() {
            const id = this.colaborador_subcategoria.categoria_id
            // const id = document.getElementById("colaborador_subcategorias-categoria").value
            const url = `${baseApiUrl}/backend/GENERAL/subcategoriasByCategoria.php?categoria=${id}`
            axios.get(url).then(res => {
                this.subcategorias = res.data.map(subcategoria => {
                    return { ...subcategoria, value: subcategoria.id, text: subcategoria.titulo }
                })
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.subcategoria =  { value: '', text: 'Selecione uma categoria antes.' }
            })
        },
        loadColaborador_subcategorias() {
            const url = `${baseApiUrl}/backend/SELECT/colaborador_subcategorias.php`
            axios.get(url).then(res => {
                this.colaborador_subcategorias = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            }
            )
        },
        reset() {
            this.colaborador_subcategoria = {}
            this.loadColaborador_subcategorias()
            this.$v.colaborador_subcategoria.$reset()
        },
        save() {
            this.$v.colaborador_subcategoria.$touch()
            if(!this.$v.colaborador_subcategoria.$error){
                const method = this.colaborador_subcategoria.id ? 'put' : 'post'
                const id = this.colaborador_subcategoria.id ? `?id=${this.colaborador_subcategoria.id}` : ''
                this.colaborador_subcategoria.id_colaborador = this.colaborador
                if(method==='post'){
                    axios['post'](`${baseApiUrl}/backend/INSERT/colaborador_subcategorias.php${id}`, this.colaborador_subcategoria)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Serviço inserido com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                } else {
                    axios['put'](`${baseApiUrl}/backend/UPDATE/colaborador_subcategorias.php${id}`, this.colaborador_subcategoria)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Serviço alterado com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                }
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(colaborador_subcategoria) {
            const sure = confirm("Deseja realmente excluir o Serviço?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/DELETE/colaborador_subcategorias.php`
                axios.delete(url, { data: colaborador_subcategoria })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Serviço excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadColaborador_subcategoria(colaborador_subcategoria) {
            this.colaborador_subcategoria = { ...colaborador_subcategoria }
            this.loadSubcategorias()
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        this.loadCategorias()
        this.loadColaborador_subcategorias()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.colaborador_subcategorias.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

#colaborador_subcategoria-colaborador, #colaborador_subcategoria-categoria, #colaborador_subcategoria-subcategoria {
    /* border: 0; */
    outline: 0;
    border-radius: 10px;
    /* border-bottom: 1px solid #AAA; */
    background-color: rgba(255,255,255,0.4);
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.text-custom {
    font-size: 0.8rem;
}

.btn-custom {
    border-radius: 10px;
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
    background-color: rgba(255,255,255,0.4);
}
</style>